module.exports = __webpack_public_path__ + "img/about-2.d4ffb1e4.jpg";